import { render, staticRenderFns } from "./imgComp.vue?vue&type=template&id=5475e542&scoped=true"
import script from "./imgComp.vue?vue&type=script&lang=js"
export * from "./imgComp.vue?vue&type=script&lang=js"
import style0 from "./imgComp.vue?vue&type=style&index=0&id=5475e542&prod&lang=less&scoped=true"
import style1 from "./imgComp.vue?vue&type=style&index=1&id=5475e542&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5475e542",
  null
  
)

export default component.exports